import styled, {css} from 'styled-components'
import {NavLink} from 'react-router-dom'

export const StyledContainerTabs = styled(NavLink)`
    ${({theme}) => css`
        color: ${theme.palette.neutral['900']};
        font-weight: 500;
        ${theme.typography.textLg};
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${theme.spacing * 2}px;

        .tab-content {
            display: flex;
            align-items: center;
            gap: ${theme.spacing}px;
            padding: ${theme.spacing * 2}px 0;
        }

        &.active {
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -3px;
                left: 0;
                width: 100%;
                height: 3px;
                background-color: ${theme.palette.primary['700']};
            }
        }
    `}
`
